export default class FlurryReportQuery {

    public static GetFlurryUsageReport = `query GetFlurryUsageReport($input: ReportInput!) {
            getFlurryUsage(input: $input) {
                date
                apiKey
                appName
                sessions
                activeDevices
                activeUsers
                newDevices
                timeSpent
                averageTimePerDevice
                averageTimePerSession
            }     
        }`;

    public static GetFlurryEventParamsReport = `query GetFlurryEventParamsReport($input: ReportInput!) {
            getFlurryEventParams(input: $input) {
                date
                apiKey
                appName
                paramValue
                eventName
                count
            }     
        }`;
}